import React from 'react';
import { useLazyQuery } from 'apollo-client-ppc';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/cssxp-client-utils';
import { fetchContactDetailsFromContactService } from './queries/fetch-contact-details-from-contact-service';
import { ContactType, getResourceAri } from './constant';

export const useFetchQuoteContactsFromContactService = () => {
  const ansClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);

  const [fetchQuoteContactDetails, { loading: quoteContactDetailsLoading }] = useLazyQuery(
    fetchContactDetailsFromContactService,
    {
      client: ansClient as any,
    }
  );

  const getQuoteContactDetails = async (quoteId: string, transactionAccountId: string) => {
    const { data } = await fetchQuoteContactDetails({
      variables: {
        resourceAri: getResourceAri(transactionAccountId, quoteId, ContactType.QUOTE_CONTACT),
        contactType: [ContactType.QUOTE_CONTACT],
        transactionAccountId: transactionAccountId,
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    });

    return data?.contactsByResource;
  };

  const getQuoteContactDetailsforCSV = async (quoteId: string, transactionAccountId: string) => {
    const { data } = await ansClient.query({
      query: fetchContactDetailsFromContactService,
      variables: {
        resourceAri: getResourceAri(transactionAccountId, quoteId, ContactType.QUOTE_CONTACT),
        contactType: [ContactType.QUOTE_CONTACT],
        transactionAccountId: transactionAccountId,
      },
    });

    return data?.contactsByResource;
  };

  return {
    getQuoteContactDetails,
    getQuoteContactDetailsforCSV,
    quoteContactDetailsLoading,
  };
};
